// Full ISO 3166-1 alpha-2 country code list.
// Display names resolved at runtime via Intl.DisplayNames (built into Node.js 13+ and all modern browsers).
// Source: https://www.iso.org/iso-3166-country-codes.html
export const COUNTRY_CODES = [
    'ZA', // South Africa first (default)
    'AF', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AG', 'AR', 'AM', 'AU',
    'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ',
    'BT', 'BO', 'BA', 'BW', 'BR', 'BN', 'BG', 'BF', 'BI', 'CV',
    'KH', 'CM', 'CA', 'CF', 'TD', 'CL', 'CN', 'CO', 'KM', 'CG',
    'CD', 'CR', 'CI', 'HR', 'CU', 'CY', 'CZ', 'DK', 'DJ', 'DM',
    'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET', 'FJ',
    'FI', 'FR', 'GA', 'GM', 'GE', 'DE', 'GH', 'GR', 'GD', 'GT',
    'GN', 'GW', 'GY', 'HT', 'HN', 'HU', 'IS', 'IN', 'ID', 'IR',
    'IQ', 'IE', 'IL', 'IT', 'JM', 'JP', 'JO', 'KZ', 'KE', 'KI',
    'KP', 'KR', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY',
    'LI', 'LT', 'LU', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH',
    'MR', 'MU', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MA', 'MZ',
    'MM', 'NA', 'NR', 'NP', 'NL', 'NZ', 'NI', 'NE', 'NG', 'MK',
    'NO', 'OM', 'PK', 'PW', 'PA', 'PG', 'PY', 'PE', 'PH', 'PL',
    'PT', 'QA', 'RO', 'RU', 'RW', 'KN', 'LC', 'VC', 'WS', 'SM',
    'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SK', 'SI', 'SB',
    'SO', 'ES', 'LK', 'SD', 'SR', 'SE', 'CH', 'SY', 'TW', 'TJ',
    'TZ', 'TH', 'TL', 'TG', 'TO', 'TT', 'TN', 'TR', 'TM', 'TV',
    'UG', 'UA', 'AE', 'GB', 'US', 'UY', 'UZ', 'VU', 'VE', 'VN',
    'YE', 'ZM', 'ZW',
];
// Resolve display names using the built-in Intl API (available in Node.js 13+ and all modern browsers)
const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
/**
 * ISO 3166-1 alpha-2 code to full country name.
 * ZA is first; remainder sorted alphabetically by resolved name.
 */
export const COUNTRY_MAP = Object.fromEntries(COUNTRY_CODES.map((code) => [code, displayNames.of(code) ?? code]));
/** Returns full country name for an ISO code, or the code itself as fallback. */
export function getCountryName(code) {
    return COUNTRY_MAP[code] ?? code;
}
/**
 * Coerce free-form country text to a known ISO 3166-1 alpha-2 code, or null.
 *
 * Accepts a code in any case ('za', 'Za') and a full country name as resolved by
 * `COUNTRY_MAP` ('South Africa'), both trimmed. Anything else - an unknown code,
 * an abbreviation, empty text - returns null rather than a guess, so a caller
 * storing the result never persists a value the country lookup cannot resolve.
 *
 * Used where country text arrives unvalidated: extraction from a scanned
 * document, CSV import, and free-text form entry.
 */
export function normaliseCountryCode(value) {
    const trimmed = value?.trim();
    if (!trimmed)
        return null;
    const upper = trimmed.toUpperCase();
    if (COUNTRY_MAP[upper])
        return upper;
    const byName = COUNTRY_CODES.find((code) => COUNTRY_MAP[code]?.toLowerCase() === trimmed.toLowerCase());
    return byName ?? null;
}
